export const SLIDERS_CONSTS = {
    GET_SLIDERS:"GET_SLIDERS",
    GET_SLIDER_BY_ID:"GET_SLIDER_BY_ID",
    CREATE_SLIDER_ITEM:"CREATE_SLIDER_ITEM",
    UPDATE_SLIDER_ITEM: "UPDATE_SLIDER_ITEM",
    DELETE_SLIDER_ITEM: "DELETE_SLIDER_ITEM",
};